<template >
  <v-layout>
    <v-panel contextual-style="primary">
      <h1 class="panel-title" slot="heading">
        Profile Reset
      </h1>
      <div slot="body">

        <form @submit.prevent="doNothing()">
          <div class="input-group">
            <div class="input-group-btn">
              <button disabled type="button" class="btn btn-default" aria-label="Help">Profile name</button>
            </div>
            <input v-bind:readonly="doingSomething" v-model="formdata.profileid" autofocus class="form-control" aria-label="Profile name" placeholder="eg: 64219991234 or bobjones">
            </div>
            <br /><div style="width:100%;" align="center"><span class="error" style="color: #ff3333">&nbsp;{{ errmsg }}&nbsp;</span></div>
            <div class="input-group" align="center">
              <div class="input-group-btn">
                <button @click="resetPIN(formdata)" v-bind:disabled="doingSomething" type="button" class="btn btn-default">PIN Reset</button>
              </div>
              <div class="input-group-btn">
                <button @click="resetProfile(formdata)" v-bind:disabled="doingSomething" type="button" class="btn btn-default">Profile Reset/Delete</button>
              </div>
            </div>
        </form>

      </div>
    </v-panel>
  </v-layout>
</template>
<script>

import profileService from '../../../services/profile';
import store from './../../../store';

export default {
  data() {
    return {
      haveResponse: false,
      doingSomething: false,
      errmsg: '',
      formdata: {
        profileid: null,
      },
    };
  },

  mounted() {
    this.errmsg = '';
    this.doingSomething = false;
  },

  methods: {
    doNothing() {
      this.errmsg = 'Please select a profile action below';
    },
    resetProfile(inputdata) {
      if (!inputdata.profileid || inputdata.profileid === '') {
        this.errmsg = 'Must supply a valid profile ID';
        return;
      }
      // console.log(inputdata);
      this.errmsg = '';
      this.doingSomething = true;
      const vm = this;
      const clearErrMsg = function clearErrMsg() { vm.doingSomething = false; vm.errmsg = ''; };
      const cbSuccess = function cbSuccess() {
        vm.doingSomething = false;
        // console.log('response');
        // console.log(response);
        vm.errmsg = 'Profile reset underway';
        setTimeout(clearErrMsg, 3000);
      };
      const cbFail = function cbFail(response) {
        vm.doingSomething = false;
        if (response && response.data && response.data.err_message) {
          vm.errmsg = `Error resetting profile - ${response.data.err_message}`;
        } else {
          vm.errmsg = 'Error resetting profile - Please try again';
        }
      };
      const cbOptions = {
        cbSuccess,
        cbFail,
      };
      let custid = 0;
      if (!store.state.auth.selected_sp || !store.state.auth.selected_sp.sp_id) {
        vm.errmsg = 'Internal error - Please logout and login again';
      }
      custid = store.state.auth.selected_sp.sp_id;
      profileService.resetProfile(custid, inputdata.profileid, cbOptions);
    },
    resetPIN(inputdata) {
      if (!inputdata.profileid || inputdata.profileid === '') {
        this.errmsg = 'Must supply a valid profile ID';
        return;
      }
      // console.log(inputdata);
      this.errmsg = '';
      this.doingSomething = true;
      const vm = this;
      // const clearErrMsg = function clearErrMsg() { vm.doingSomething = false; vm.errmsg = ''; };
      const cbSuccess = function cbSuccess(response) {
        // console.log('response');
        // console.log(response);
        if (response && response.data && response.data.new_pin) {
          vm.errmsg = `New PIN code is ${response.data.new_pin}`;
        } else {
          vm.errmsg = 'PIN reset underway - please wait';
        }
        vm.doingSomething = false;
        // setTimeout(clearErrMsg, 1000);
      };
      const cbFail = function cbFail(response) {
        vm.doingSomething = false;
        if (response && response.data && response.data.err_message) {
          vm.errmsg = `Error resetting PIN - ${response.data.err_message}`;
        } else {
          vm.errmsg = 'Error resetting PIN - Please try again';
        }
      };
      const cbOptions = {
        cbSuccess,
        cbFail,
      };
      let custid = 0;
      if (!store.state.auth.selected_sp || !store.state.auth.selected_sp.sp_id) {
        vm.errmsg = 'Internal error - Please logout and login again';
      }
      custid = store.state.auth.selected_sp.sp_id;
      profileService.resetPIN(custid, inputdata.profileid, cbOptions);
    },
    selectList(newlistid) {
      if (newlistid && newlistid.type) {
        if (newlistid.type === 'global') {
          return;
        }
      }
      this.$router.push({
        name: 'lists.edit',
        params: {
          listid: newlistid.list_id,
        },
      });
    },
  },

  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
  },
};

</script>
<style>
tr.editable:hover {
  background: #eeeef2;
  /*cursor:context-menu;*/
  cursor:pointer;
}
td.green {
  color: #00aa00;
}
span.readonly {
  color: #aaaaaa;
}
td.red {
  color: #aa0000;
}
</style>



// WEBPACK FOOTER //
// index.vue?7808a889